var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 18C25.1041 18 25.9995 18.8954 25.9995 20V28C25.9995 29.1046 25.1041 30 23.9995 30C22.895 30 21.9995 29.1046 21.9995 28V20C21.9995 18.8954 22.895 18 23.9995 18Z",
    fill: "#F75151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9995 38C25.1041 38 25.9995 37.1046 25.9995 36C25.9995 34.8954 25.1041 34 23.9995 34C22.895 34 21.9995 34.8954 21.9995 36C21.9995 37.1046 22.895 38 23.9995 38Z",
    fill: "#F75151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8696 8.68267C19.9573 6.88951 21.9023 5.79443 23.9996 5.79443C26.0968 5.79443 28.0419 6.88951 29.1296 8.68267L29.1353 8.69216L46.0753 36.9722L46.0915 36.9998C47.1576 38.846 47.164 41.1192 46.1083 42.9714C45.0525 44.8235 43.0933 45.9764 40.9615 45.9998L40.9396 46L7.03757 45.9999C4.90581 45.9765 2.94657 44.8235 1.89085 42.9714C0.835132 41.1192 0.841497 38.846 1.90757 36.9998L1.92382 36.9722L18.8638 8.69218L18.8696 8.68267ZM22.292 10.7532L5.36492 39.0116C5.01616 39.6249 5.01625 40.377 5.36596 40.9906C5.71635 41.6053 6.36532 41.9889 7.07234 41.9999H40.9268C41.6338 41.9889 42.2828 41.6053 42.6331 40.9906C42.9828 40.3771 42.9829 39.625 42.6342 39.0117L25.7096 10.7572L25.7071 10.7532C25.3441 10.1578 24.6971 9.79443 23.9996 9.79443C23.302 9.79443 22.655 10.1578 22.292 10.7532Z",
    fill: "#F75151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.1fca30dd.svg";
export { ForwardRef as ReactComponent };